import { render } from "./VideoGaleryView.vue?vue&type=template&id=98de06e4"
import script from "./VideoGaleryView.vue?vue&type=script&lang=js"
export * from "./VideoGaleryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__